var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"plugin-home-about"},[(_vm.title)?_c('h1',{staticClass:"plugin-home-about__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('div',{staticClass:"plugin-home-about__sliders"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }